import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import { fetchMealItemListAsync } from './mealItemListSlice';
import { MealItemFormModel } from '../../../app/data/models/mealItems/mealItemFormModel';

export interface CreateMealItemState {
  status: string;
  dismiss: boolean;
}

const initialState: CreateMealItemState = {
  status: 'idle',
  dismiss: false,
};

export const createMealItemAsync = createAsyncThunk<
  void,
  { restaurantId: string; data: MealItemFormModel }
>('mealItems/create', async ({ restaurantId, data }, thunkApi) => {
  try {
    await api.MealItem.create(restaurantId, data);
    thunkApi.dispatch(fetchMealItemListAsync(restaurantId));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return thunkApi.rejectWithValue({ error: error.data });
  }
});

export const createMealItemSlice = createSlice({
  name: 'createMealItem',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createMealItemAsync.pending, (state) => {
      state.status = 'pendingCreateMealItem';
    });
    builder.addCase(createMealItemAsync.fulfilled, (state) => {
      state.status = 'idle';
      state.dismiss = true;
    });
    builder.addCase(createMealItemAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
